/**
 * PWA Handler - Managed Service Worker registration and Installation Prompt
 * Last Updated: 2026-04-06
 */

export function initPWA() {
    // 1. Service Worker Registration via VitePWA logic
    // Usually injected automatically, but we can also use the virtual module if needed.
    
    let deferredPrompt: any = null;

    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        
        console.log('[PWA] beforeinstallprompt event fired');
        
        // Show install button in UI if desired
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'block';
        }
    });

    window.addEventListener('appinstalled', (evt) => {
        console.log('[PWA] App was installed.');
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'none';
        }
    });

    // Handle global click for the install button
    (window as any).triggerPWAInstall = async () => {
        if (!deferredPrompt) {
            console.log('[PWA] No deferred prompt available.');
            return;
        }
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`[PWA] User response to the install prompt: ${outcome}`);
        // We've used the prompt, and can't use it again, throw it away
        deferredPrompt = null;
        
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) {
            installBtn.style.display = 'none';
        }
    };
}
